import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { RoutingForm } from '@components/Numbers/Details/Form';

export const RoutingTab = ({ did, customerTrunk }) => (
  <Row>
    <Col>
      <RoutingForm did={did} customerTrunk={customerTrunk} />
    </Col>
  </Row>
);
